var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.validation.destroy)?_c('apexchart',{staticClass:"bar-chart",attrs:{"height":"320","type":"bar","options":_vm.options,"series":_vm.settings.series}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }